import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { NgIf, NgClass } from '@angular/common';


@Component({
    selector: 'app-inclusions-management',
    templateUrl: './inclusions-management.component.html',
    styleUrls: ['./inclusions-management.component.scss'],
    standalone: true,
    imports: [NgIf, NgClass]
})
export class InclusionsManagementComponent implements OnInit {

  @Input() item;
  @Output() itemChanged: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  changeInclusion(item) {
    item.included = !item.included;
    this.itemChanged.emit(item.included);
  }


}
